var _path, _circle, _circle2, _circle3, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaWebsites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "outline",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472,16H40A24.0275,24.0275,0,0,0,16,40V472a24.0275,24.0275,0,0,0,24,24H472a24.0275,24.0275,0,0,0,24-24V40A24.0275,24.0275,0,0,0,472,16ZM40,32H472a8.00917,8.00917,0,0,1,8,8V64H32V40A8.00917,8.00917,0,0,1,40,32ZM472,480H40a8.00917,8.00917,0,0,1-8-8V80H480V472A8.00917,8.00917,0,0,1,472,480Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 48,
    r: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 48,
    r: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104,128a24,24,0,1,0-24,24A24.02718,24.02718,0,0,0,104,128Zm-32,0a8,8,0,1,1,8,8A8.00917,8.00917,0,0,1,72,128Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 104,
    width: 16,
    height: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 104,
    width: 96,
    height: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 136,
    width: 56,
    height: 16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 136,
    width: 16,
    height: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440,176H72a8.00008,8.00008,0,0,0-8,8V384a8.00008,8.00008,0,0,0,8,8H440a8.00008,8.00008,0,0,0,8-8V184A8.00008,8.00008,0,0,0,440,176Zm-8,16V296.29028l-75.29492-54.76a7.99944,7.99944,0,0,0-9.41016,0l-19.31616,14.04834A7.99341,7.99341,0,0,0,320,248h-8a8.00008,8.00008,0,0,0-8-8H288a8.00008,8.00008,0,0,0-8,8H267.31348l-13.65625-13.65674A8.00076,8.00076,0,0,0,248,232H192a7.99193,7.99193,0,0,0-6.64087,3.53882l-12.39331-9.81128a7.99994,7.99994,0,0,0-9.76562-.12744L80,288.00024V192ZM312,264v16H275.56934a27.93494,27.93494,0,0,0-39.13868,0H200V248h44.68652l13.65625,13.65674A8.00076,8.00076,0,0,0,264,264Zm-44,36a12,12,0,1,1-12-12A12.01343,12.01343,0,0,1,268,300Zm-68-4h28.29028a28,28,0,1,0,55.41944,0H312v40H200ZM80,307.99976l87.86816-65.90064L184,254.87036V344a8.00008,8.00008,0,0,0,8,8H306.68994l30.31592,24H80ZM362.78369,376l-35.70923-28.26978A7.96122,7.96122,0,0,0,328,344V275.34644l24-17.45435,80,58.1814V376Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.68652,408A19.16911,19.16911,0,0,0,96,412.749a19.3145,19.3145,0,0,0-26.34375,28.22119l20.68652,20.68653a8.00063,8.00063,0,0,0,11.31446,0l20.68652-20.687A19.31355,19.31355,0,0,0,108.68652,408Zm2.34278,21.65674L96,444.68652,80.9707,429.65723a3.3137,3.3137,0,1,1,4.68555-4.687l4.68652,4.68653a8.00122,8.00122,0,0,0,11.31446,0l4.68652-4.687a3.3137,3.3137,0,0,1,4.68555,4.687Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164,408a28,28,0,1,0,28,28A28.03146,28.03146,0,0,0,164,408Zm0,40a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,164,448Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.57812,428.84473l-40-20A8,8,0,0,0,208,416v40a8.00009,8.00009,0,0,0,11.57812,7.15527l40-20a8.00009,8.00009,0,0,0,0-14.31054ZM224,443.05566V428.94434L238.11133,436Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaWebsites);
export default __webpack_public_path__ + "static/media/Social Media Websites.fc5df3b08a282dd0fd3b8bd8496dffe6.svg";
export { ForwardRef as ReactComponent };